// extracted by mini-css-extract-plugin
export default {"airplaneSizingContainer":"vaa-z","narrowOptionButtons":"waa-z","noOptions":"xaa-z"};